import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from '@/App.vue'
import router from '@/router/index.js'
import '@/assets/css/tailwind.css'
import VueCookies from 'vue3-cookies'
import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput';
import MazInputTags  from 'maz-ui/components/MazInputTags';
import MazSelect from 'maz-ui/components/MazSelect';
import MazInput from 'maz-ui/components/MazInput';
import MazInputPrice from 'maz-ui/components/MazInputPrice';
import MazRadio from 'maz-ui/components/MazRadio';
import MazAvatar from 'maz-ui/components/MazAvatar';
import MazPicker from 'maz-ui/components/MazPicker';
import MazCheckbox from 'maz-ui/components/MazCheckbox';
import MazTextarea from 'maz-ui/components/MazTextarea';
import MazInputCode from 'maz-ui/components/MazInputCode';
import MazDropdown from 'maz-ui/components/MazDropdown';
import MazBtn from 'maz-ui/components/MazBtn';
import MazTabs from 'maz-ui/components/MazTabs';
import MazSwitch from 'maz-ui/components/MazSwitch';
import MazTabsBar from 'maz-ui/components/MazTabsBar';
import MazTabsContent from 'maz-ui/components/MazTabsContent';
import MazDialog from 'maz-ui/components/MazDialog';
import MazTabsContentItem from 'maz-ui/components/MazTabsContentItem';
import 'maz-ui/css/main.css';
import moment from 'moment-timezone';
import { createI18n } from 'vue-i18n'
import en from './assets/i18n/en.json'
import es from './assets/i18n/es.json'
import ro from './assets/i18n/ro.json'
import fr from './assets/i18n/fr.json'
import de from './assets/i18n/de.json'
import ru from './assets/i18n/ru.json'
import nl from './assets/i18n/nl.json'
import axiosInstance from './api/axiosInstance';
//import VueApexCharts from 'vue3-apexcharts';
import * as Sentry from "@sentry/vue";

// Import and configure Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCrown, faRepeat, faFilePen, faSyncAlt, faFingerprint, faHandHoldingDollar, faFolderPlus, faTowerBroadcast, faLocationDot, faMagnifyingGlass, faCaretLeft, faBuildingUser, faCaretRight, faPhone, faComments, faInfo, faAngleLeft, faAngleRight, faCaretUp, faServer, faCaretDown, faChartColumn, faSackDollar, faTableList, faAngleDown, faAnglesDown, faKey, faAngleUp, faTableColumns, faTableCellsLarge, faHandshakeSimple, faCommentDollar, faComment, faCalendarDays, faDollarSign, faShareNodes, faScrewdriverWrench, faCogs, faShuffle, faArrowRightFromBracket, faArrowRight, faXmark, faBars, faCircle, faSpinner, faFire, faQuestionCircle, faFilterCircleXmark, faFilter, faPlus, faGrip, faFloppyDisk, faDownload, faChevronDown, faChevronUp, faChevronRight, faUser, faChevronLeft, faUpRightFromSquare, faHeart, faLaptop, faChartBar, faRobot, faUserGroup, faUserShield, faArrowUpRightDots, faSeedling, faUsersCog, faArrowsRotate, faToggleOn, faToggleOff, faBullhorn, faDesktop, faReceipt, faPuzzlePiece, faStar, faStarHalfStroke, faPen, faArrowUp, faCheck, faCheckSquare, faSquare, faCirclePlus, faCircleMinus, faSort, faArrowLeft, faArchive, faUndo, faCirclePlay, faPlay, faCirclePause, faTrashCan, faExclamation, faLink, faPenToSquare, faArrowUpRightFromSquare, faEye, faEyeSlash, faFileCircleExclamation, faCircleCheck, faFileCircleCheck, faExclamationCircle, faExclamationTriangle, faEllipsis, faUserLock, faLock, faLockOpen, faClockRotateLeft, faRotateLeft, faRedo, faUserXmark, faRightLeft, faDatabase, faLayerGroup, faCoins, faUserPlus, faUserClock, faClock, faArrowTrendUp, faArrowTrendDown, faUsers, faMessage, faPaste, faArrowPointer, faComputerMouse, faPercent, faTrophy, faPeopleGroup, faUserTie, faMoon, faSun } from '@fortawesome/free-solid-svg-icons';
import { faSquare as farSquare, faNoteSticky as farNoteSticky, faBuilding as farBuilding, faCircleQuestion as farCircleQuestion, faCopy as farCopy, faEnvelope as farEnvelope, faSmile } from '@fortawesome/free-regular-svg-icons'
import { faInstagram, faFacebook, faYoutube, faSquareFacebook, faWhatsapp, faXTwitter, faWindows, faApple } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const app = createApp(App)
const pinia = createPinia();

if (window.location.hostname !== 'localhost') {
  Sentry.init({
    app,
    dsn: "https://7b237bf94916eae060c6535012223421@o4508780107005952.ingest.de.sentry.io/4508780116050000",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/creatorxone\.com/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'

// Create i18n instance
const i18n = createI18n({
    locale: 'en', // set default locale
    fallbackLocale: 'en', // fallback locale in case the current locale translation is missing
    messages: {
      en,
      es,
      fr,
      ro,
      de,
      ru,
      nl
    }
})

app.config.globalProperties.$getPermission = function (permissions, permission_id) {
  // Check if permissions is an array and permission_id is valid
  if (Array.isArray(permissions) && permission_id != null) {
      const permission = permissions.find(p => p.permission_id === permission_id);
      return permission 
          ? { is_granted: Boolean(permission.is_granted), scope: permission.scope } 
          : null;
  }
  
  // Return null if permissions is invalid or not an array
  return null;
}

import onlyfansLogo from '@/assets/images/of_logo.png';
import fanslyLogo from '@/assets/images/fansly_logo.png';
import redditLogo from '@/assets/images/reddit_logo.png';
import xLogo from '@/assets/images/x_logo.png';
import sexcomLogo from '@/assets/images/sexcom_logo.png';
import fancentroLogo from '@/assets/images/fancentro_logo.png';

app.config.globalProperties.$platformLogo = function (model) {
  if (!model) {
    return '';
  }
  const logoMap = {
      Onlyfans: onlyfansLogo,
      Fansly: fanslyLogo,
      Reddit: redditLogo,
      X: xLogo,
      Sexcom: sexcomLogo,
      Fancentro: fancentroLogo
  };

  return model?.platformName ? logoMap[model?.platformName.replace(".","")] : '';
}

app.config.globalProperties.$axios = axiosInstance;
app.config.globalProperties.$moment = moment;
app.component('FontAwesomeIcon', FontAwesomeIcon);
const components = {
  MazPhoneNumberInput,
  MazInputTags,
  MazSelect,
  MazInput,
  MazInputPrice,
  MazRadio,
  MazPicker,
  MazCheckbox,
  MazAvatar,
  MazBtn,
  MazTextarea,
  MazInputCode,
  MazDropdown,
  MazDialog,
  MazTabs,
  MazSwitch,
  MazTabsBar,
  MazTabsContent,
  MazTabsContentItem
};

Object.entries(components).forEach(([name, component]) => {
  app.component(name, component);
});
library.add(faCrown, faRepeat, faSyncAlt, faFacebook, faYoutube, faFingerprint, faFolderPlus, faFilePen, faHandHoldingDollar, faTowerBroadcast, faLocationDot, faXTwitter, faWindows, faApple, faMoon, faMagnifyingGlass, farBuilding, faBuildingUser, farCircleQuestion, faInstagram, farEnvelope, faSquareFacebook, faInfo, faWhatsapp, faPhone, faServer, faComments, farSquare, faCaretLeft, faAngleLeft, faKey, faAngleRight, faAngleUp, faCaretRight, faCaretUp, faCaretDown, faSackDollar, faChartColumn, faHandshakeSimple, faAngleDown, faAnglesDown, faTableList, faTableColumns, faTableCellsLarge, faCommentDollar, faComment, faCalendarDays, faDollarSign, faShareNodes, faScrewdriverWrench, faCogs, faShuffle, faArrowRightFromBracket, faArrowRight, faXmark, faBars, faCircle, faSpinner, faFire, faQuestionCircle, faFilterCircleXmark, faFilter, faPlus, faUser, faGrip, faFloppyDisk, faDownload, faChevronUp, faChevronDown, faChevronRight, faChevronLeft, faUpRightFromSquare, faHeart, faToggleOn, faToggleOff, faSeedling, faLaptop, faChartBar, faRobot, faUserGroup, faArrowUpRightDots, faUserShield, faUsersCog, faArrowsRotate, faBullhorn, faDesktop, faReceipt, faPuzzlePiece, faStar, faStarHalfStroke, faPen, faArrowUp, faCheck, faCheckSquare, faSquare, faCirclePlus, faCircleMinus, faSort, faArrowLeft, faArchive, faUndo, faCirclePlay, faPlay, faCirclePause, faTrashCan, faExclamation, faLink, faPenToSquare, faArrowUpRightFromSquare, faEye, faEyeSlash, faFileCircleExclamation, faCircleCheck, faFileCircleCheck, faExclamationCircle, faExclamationTriangle, faEllipsis, faUserLock, faLock, faLockOpen, faClockRotateLeft, farNoteSticky, faRotateLeft, faRedo, faUserXmark, faRightLeft, faDatabase, faLayerGroup, faCoins, faUserPlus, faUserClock, faClock, faArrowTrendUp, faArrowTrendDown, faUsers, faMessage, faPaste, farSquare, faArrowPointer, faComputerMouse, faPercent, farCopy, faSmile, faTrophy, faPeopleGroup, faUserTie, faSun);

app.use(i18n)
  //.use(VueApexCharts)
  .use(router)
  .use(pinia)
  .use(VueCookies)
  .component('VueDatePicker', VueDatePicker)
  .mount('#app')

if (window && window.electron && typeof window.electron.signalAppReady === 'function') {
  window.electron.signalAppReady();
}